var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignmentMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.125,
    height: 14.286,
    viewBox: "0 0 19.125 14.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11965",
    "data-name": "Group 11965",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_81e98e3a69bdb6690515c719833a59fa",
    "data-name": "81e98e3a69bdb6690515c719833a59fa",
    d: "M13.857,3V16.285M8.691,7.428,10.9,9.643m0,0L8.691,11.857M10.9,9.643H5",
    transform: "translate(-5 -3)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "_81e98e3a69bdb6690515c719833a59fa-2",
    "data-name": "81e98e3a69bdb6690515c719833a59fa",
    d: "M3.691,0,5.9,2.214m0,0L3.691,4.428M5.9,2.214H0",
    transform: "translate(18.126 8.857) rotate(180)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentMiddle);
export default __webpack_public_path__ + "static/media/alignment-middle.1c49ddf96384612821ccd3deba63c0d9.svg";
export { ForwardRef as ReactComponent };